import React from 'react';
import { NavLink } from 'react-router-dom';

const MassHead = ({hasBeenRead}) => {

	return (

		<header className="App-header">
			<nav className='tc ph4'>
			  <div className="tc pb3 flex flex-column items-left">
			    <NavLink exact className="link grow black f6 f5-ns dib pa2" to="/wp-export-file-parser" title="Main">Main</NavLink>
			    {
			    	hasBeenRead ?
			    	<div className='flex items-center flex-auto'>
					    <NavLink exact className="link grow black f6 f5-ns dib ph3 pv2" to="/wp-export-file-parser/menu" title="About">Menu</NavLink>
					    <NavLink exact className="link grow black f6 f5-ns dib ph3 pv2" to="/wp-export-file-parser/pages" title="Pages">Pages</NavLink>
						<NavLink exact className="link grow black f6 f5-ns dib ph3 pv2" to="/wp-export-file-parser/posts" title="Posts">Posts</NavLink>
				   </div> : ''
				}
			  </div>
			</nav>
		</header>
		)
}

export default MassHead;
